export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <span className="font-brand text-2xl text-primary-500">暗网吃瓜</span>
            <p className="text-sm text-foreground-600 leading-relaxed mt-3">
              暗网吃瓜是国内领先的暗网吃瓜论坛与吃瓜群聚合平台，聚焦黑料讨论和爆料交流，为你带来真实吃瓜、隐秘八卦和新爆料，打造全网最快的吃瓜速递。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-300 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#cards" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">热门爆料</a>
              <a href="#media" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">吃瓜现场</a>
              <a href="#index" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">爆料合集</a>
              <a href="#comments" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">瓜友热议</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-300 mb-4">热门话题</h4>
            <div className="flex flex-col gap-2">
              <a href="#cards" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">娱乐圈爆料</a>
              <a href="#cards" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">网红翻车</a>
              <a href="#cards" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">互联网大厂</a>
              <a href="#cards" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">社会热点追踪</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-300 mb-4">合作伙伴</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-600">更多合作伙伴即将入驻</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-300 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 暗网吃瓜 · 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
            <a href="#faq" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            <a href="#contact" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}